import { GlIcon, GlLoadingIcon, GlDisclosureDropdownItem } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapState, mapActions } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { TYPE_ISSUE } from '~/issues/constants';
import { __, sprintf } from '~/locale';
import { createAlert } from '../../../alert.js?vue3';
import toast from '../../../vue_shared/plugins/global_toast.js?vue3';
import { useNotes } from '../../../notes/store/legacy_notes/index.js?vue3';
import eventHub from '../../event_hub';
export default {
    name: 'IssuableLockForm',
    locked: {
        icon: 'lock',
        class: 'value',
        displayText: __('Locked')
    },
    unlocked: {
        class: [
            'no-value hide-collapsed'
        ],
        icon: 'lock-open',
        displayText: __('Unlocked')
    },
    components: {
        GlIcon,
        GlLoadingIcon,
        GlDisclosureDropdownItem
    },
    inject: [
        'fullPath'
    ],
    props: {
        isEditable: {
            required: true,
            type: Boolean
        }
    },
    i18n: {
        issue: __('issue'),
        issueCapitalized: __('Issue'),
        mergeRequest: __('merge request'),
        mergeRequestCapitalized: __('Merge request'),
        lockingMergeRequest: __('Locking discussion'),
        unlockingMergeRequest: __('Unlocking discussion'),
        lockMergeRequest: __('Lock discussion'),
        unlockMergeRequest: __('Unlock discussion'),
        lockedMessage: __('Discussion locked.'),
        unlockedMessage: __('Discussion unlocked.')
    },
    data () {
        return {
            isLoading: false,
            isLockDialogOpen: false
        };
    },
    computed: {
        ...mapState(useNotes, [
            'getNoteableData'
        ]),
        isIssuable () {
            return this.getNoteableData.targetType === TYPE_ISSUE;
        },
        issuableDisplayName () {
            return this.isIssuable ? this.$options.i18n.issue : this.$options.i18n.mergeRequest;
        },
        issuableDisplayNameCapitalized () {
            return this.isIssuable ? this.$options.i18n.issueCapitalized : this.$options.i18n.mergeRequestCapitalized;
        },
        isLocked () {
            return this.getNoteableData.discussion_locked;
        },
        lockToggleInProgressText () {
            return this.isLocked ? this.unlockingMergeRequestText : this.lockingMergeRequestText;
        },
        lockToggleText () {
            return this.isLocked ? this.unlockMergeRequestText : this.lockMergeRequestText;
        },
        lockToggleIcon () {
            return this.isLocked ? 'lock-open' : 'lock';
        },
        lockingMergeRequestText () {
            return sprintf(this.$options.i18n.lockingMergeRequest, {
                issuableDisplayName: this.issuableDisplayName
            });
        },
        unlockingMergeRequestText () {
            return sprintf(this.$options.i18n.unlockingMergeRequest, {
                issuableDisplayName: this.issuableDisplayName
            });
        },
        lockMergeRequestText () {
            return sprintf(this.$options.i18n.lockMergeRequest, {
                issuableDisplayName: this.issuableDisplayName
            });
        },
        unlockMergeRequestText () {
            return sprintf(this.$options.i18n.unlockMergeRequest, {
                issuableDisplayName: this.issuableDisplayName
            });
        },
        lockedMessageText () {
            return sprintf(this.$options.i18n.lockedMessage, {
                issuableDisplayName: this.issuableDisplayNameCapitalized
            });
        },
        unlockedMessageText () {
            return sprintf(this.$options.i18n.unlockedMessage, {
                issuableDisplayName: this.issuableDisplayNameCapitalized
            });
        }
    },
    created () {
        eventHub.$on('closeLockForm', this.toggleForm);
    },
    beforeDestroy () {
        eventHub.$off('closeLockForm', this.toggleForm);
    },
    methods: {
        ...mapActions(useNotes, [
            'updateLockedAttribute'
        ]),
        toggleForm () {
            if (this.isEditable) {
                this.isLockDialogOpen = !this.isLockDialogOpen;
            }
        },
        toggleLocked () {
            this.isLoading = true;
            this.updateLockedAttribute({
                locked: !this.isLocked,
                fullPath: this.fullPath
            }).then(()=>{
                toast(this.isLocked ? this.lockedMessageText : this.unlockedMessageText);
            }).catch(()=>{
                const alertMessage = __('Something went wrong trying to change the locked state of the discussion');
                createAlert({
                    message: sprintf(alertMessage, {
                        issuableDisplayName: this.issuableDisplayName
                    })
                });
            }).finally(()=>{
                this.isLoading = false;
            });
        }
    }
};
